import { render } from "./ConsentInformation.vue?vue&type=template&id=69f520a9"
import script from "./ConsentInformation.vue?vue&type=script&lang=js"
export * from "./ConsentInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__